import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * @deprecated This function is deprecated. Use `clsx` and `class-variance-authority` instead.
 */
const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs))
}

export default cn
